/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  Form,
  Icon,
  Layout,
  Row,
  Spin,
  Upload,
  Avatar,
  Switch,
  Card,
  notification,
  Typography,
  Radio,
  Input,
  Select,
} from 'antd';
import { institutionService } from '../../services/institution.service';
import Api from '../../helpers/api';
import { intitutionSettings } from '../../constants/intitutionSettings.constants';

const FormItem = Form.Item;
const { Content } = Layout;
const { TextArea } = Input;

const styles = {
  spaceBetweenRadioOptions: {
    marginTop: 8,
    marginLeft: 11,
    fontWeight: 400,

  },
};

const DRUG_CONSUMPTION_SETTINGS = [
  {
    key: 'vialReuse',
    settingId: intitutionSettings.CONFIG_ID_VIAL_REUSE,
    label: 'Reutilizar frascos cheios em múltiplas administrações?',
    defaultValue: true,
  },
  {
    key: 'ampouleReuse',
    settingId: intitutionSettings.CONFIG_ID_AMPOULE_REUSE,
    label: 'Reutilizar ampolas cheias em múltiplas administrações?',
    defaultValue: true,
  },
  {
    key: 'vialPartialCriterion',
    settingId: intitutionSettings.CONFIG_ID_VIAL_PARTIAL_CRITERION,
    label: 'Contabilizar frascos parcialmente utilizados de forma proporcional?',
    defaultValue: false,
  },
  {
    key: 'ampoulePartialCriterion',
    settingId: intitutionSettings.CONFIG_ID_AMPOULE_PARTIAL_CRITERION,
    label: 'Contabilizar ampolas parcialmente utilizadas de forma proporcional?',
    defaultValue: false,
  },
];

class Institution extends Component {
    // eslint-disable-next-line react/state-in-constructor
    state = {
      logo64: null,
      institution: {},
      loading: false,
      institution_logo: [],
      value: 0,
      pdfHistoric: false,
      loadingPdfSettings: true,
      pdfGroupHistoric: false,
      loadingGroupPdfSettings: true,
      activatePre: true,
      focusedTextArea: false,
      blockAgendaCreation: false,
      isSettingExisting: false,
      isAdmin: false,
      pscType: null,
      pscClientId: '',
      pscClientSecret: '',
      drugConsumptionSettings: DRUG_CONSUMPTION_SETTINGS.reduce((acc, { key, defaultValue }) => {
        acc[key] = { value: defaultValue, exists: false };
        return acc;
      }, {}),
    };

    componentDidMount() {
      const selectedInstitution = JSON.parse(localStorage.getItem('selected-institution'));
      const userPermissions = JSON.parse(localStorage.getItem('user-permissions'));
      this.setState({
        institution: selectedInstitution,
        isAdmin: !!(userPermissions && userPermissions.is_admin),
      });

      Api.get(`/institution/${selectedInstitution.id}/settings/pdf`)
        .then((data) => {
          let pscCredentials = {};
          if (data.pscCredentials) {
            try {
              pscCredentials = JSON.parse(data.pscCredentials);
            } catch (err) {
              console.warn(err);              
            }
          }
          this.setState({
            value: data.drugsPrintSettings,
            pdfHistoric: data.pdfPrintSettings,
            loadingPdfSettings: false,
            pdfGroupHistoric: data.anaesthesiaGroupPrintSettings,
            loadingGroupPdfSettings: false,
            activatePre: data.activatePre,
            pscClientId: pscCredentials.pscClientId || '',
            pscClientSecret: pscCredentials.pscClientSecret || '',
            pscType: data.pscType,
          });
        })
        .catch(() => {
          notification.error({
            message: 'Erro ao carregar dados, verifique sua conexão com a internet',
          });
        });
        
        Api.get(`/institutions/settings/38`)
        .then((response) => {
          if (response && typeof response.value !== 'undefined') {
            const settingActive = response.value === '1'; 
            this.setState({
              blockAgendaCreation: settingActive,
              isSettingExisting: true  
            });
          } else {
            console.error("Formato inesperado da resposta da API:", response);
          }
        })
        .catch((error) => {
          if (error.status === 404) {
            this.setState({ isSettingExisting: false });
          } else {
            console.error("Erro na requisição ou no processamento dos dados:", error);
            notification.error({
              message: 'Erro ao carregar dados de configuração de agendamentos',
            });
          }
        });

      Promise.all(
        DRUG_CONSUMPTION_SETTINGS.map(({ key, settingId, defaultValue }) => Api.get(`/institutions/settings/${settingId}`)
          .then((response) => ({ key, value: response.value === '1', exists: true }))
          .catch((error) => {
            if (error.status !== 404) {
              console.error('Erro ao carregar configuração de consumo de fármacos:', error);
            }
            return { key, value: defaultValue, exists: false };
          })),
      ).then((results) => {
        this.setState((prevState) => ({
          drugConsumptionSettings: results.reduce((acc, { key, value, exists }) => {
            acc[key] = { value, exists };
            return acc;
          }, { ...prevState.drugConsumptionSettings }),
        }));
      });
    }
    
        
    onChange = (e) => {
      this.setState({
        value: e.target.value,
      });
    };

    toBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    viewLogo = async (file) => {
      const result = await this.toBase64(file).catch((e) => Error(e));
      if (result instanceof Error) {
        console.error('Error: ', result.message);
        return;
      }

      this.setState({ logo64: result });
    }

    sendLogoToAPI = (uuid, file) => {
      if (this.state.institution_logo.length === 0) { // não houve alteração de imagem
        window.location.reload(false);
        this.setState({ loading: false });
        notification.success({
          message: 'Dados da instituição alterados com sucesso',
        });
        return;
      }

      institutionService.saveInstitutionLogo(uuid, file)
        .then(() => {
          this.props.history.push('/');
          this.setState({ loading: false });
          notification.success({
            message: 'Dados da instituição alterados com sucesso',
          });
        }).catch(() => {
          notification.error({
            message: 'Erro ao atualizar o logotipo da instituição',
          });
          this.setState({ loading: false });
        });
    }

    putPdfSettings = () => {
      const { pscType } = this.state;

      return Api.post(`/institution/${this.state.institution.id}/settings/pdf`, {
        pdfPrintSettings: this.state.pdfHistoric,
        drugsPrintSettings: this.state.value,
        anaesthesiaGroupPrintSettings: this.state.pdfGroupHistoric,
        activatePre: this.state.activatePre,
        platform: 'maneger',
        ...(pscType !== null ? {
          pscClientId: this.state.pscClientId,
          pscClientSecret: this.state.pscClientSecret,
          pscType,
        } : {}),
      });
    };

    checkAndSaveSettings = async () => {
      if (this.state.isSettingExisting) {
        await this.updateScheduleSettings();
      } else {
        await this.createScheduleSettings();
      }
    };
    
    
    createScheduleSettings = () => Api.post(`/institutions/settings`, {
        institution_id: this.state.institution.id,
        institution_setting_id: 38,
        value: this.state.blockAgendaCreation ? "1" : "0",
        platform: 'maneger',
      })
    
    updateScheduleSettings = () =>  Api.put(`/institutions/settings/38`, {
        institution_id: this.state.institution.id,
        value: this.state.blockAgendaCreation ? "1" : "0", 
        platform: 'maneger',
      })
    
    
    handleSwitchChange = (checked) => {
      this.setState({ blockAgendaCreation: checked });
    };

    handleDrugConsumptionSettingChange = (key) => (checked) => {
      this.setState((prevState) => ({
        drugConsumptionSettings: {
          ...prevState.drugConsumptionSettings,
          [key]: { ...prevState.drugConsumptionSettings[key], value: checked },
        },
      }));
    };

    saveDrugConsumptionSettings = () => {
      const { drugConsumptionSettings, institution } = this.state;
      const toCreate = [];
      const updatePromises = [];

      DRUG_CONSUMPTION_SETTINGS.forEach(({ key, settingId }) => {
        const setting = drugConsumptionSettings[key];
        const value = setting.value ? '1' : '0';

        if (setting.exists) {
          updatePromises.push(Api.put(`/institutions/settings/${settingId}`, {
            institution_id: institution.id,
            value,
          }));
        } else {
          toCreate.push({
            institution_id: institution.id,
            institution_setting_id: settingId,
            value,
          });
        }
      });

      const createPromise = toCreate.length
        ? Api.post('/institutions/settings', toCreate)
        : Promise.resolve();

      return Promise.all([createPromise, ...updatePromises]).then(() => {
        this.setState((prevState) => ({
          drugConsumptionSettings: Object.keys(prevState.drugConsumptionSettings).reduce(
            (acc, key) => {
              acc[key] = { ...prevState.drugConsumptionSettings[key], exists: true };
              return acc;
            },
            {},
          ),
        }));
      });
    };

    handleSubmit = async (uuid, file) => {
      this.setState({ loading: true });
      try {
        await this.putPdfSettings();
        await this.checkAndSaveSettings();
        await this.saveDrugConsumptionSettings();
        this.sendLogoToAPI(uuid, file);
      } catch (error) {
        notification.error({
          message: 'Erro ao atualizar configurações',
        });
        this.setState({ loading: false });
      }
    };
    

    handleChange(e) {
      e.preventDefault();
    }

    checkValidateFormat = (values) => {
      if (values) {
        const { size, type } = values;
        const typePermissions = ['png', 'jpg', 'jpeg'];
        const sizePermission = 120000; // 120kb
        if (size > sizePermission || !typePermissions.includes(type.split('/')[1])) {
          notification.error({
            message: 'O arquivo selecionado excede o tamanho máximo ou formato permitido.',
          });
          this.setState({
            institution_logo: [],
          });
          return false;
        }
      }
      return true;
    }

    render() {
      const {
        value, pdfHistoric, loadingPdfSettings, pdfGroupHistoric, loadingGroupPdfSettings, activatePre,
        blockAgendaCreation, drugConsumptionSettings, isAdmin,
      } = this.state;
      if (this.state.loading) {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Spin spinning={this.loading} />
          </div>
        );
      }
      return (
        <Content>
          <Form>
            <Row>
              <Col xs={24} sm={0}>
                <Button
                  type="primary"
                  className="add-procedure"
                  shape="circle"
                  size="large"
                  htmlType="submit"
                >
                  <Icon type="check" fill="#ffffff" />
                </Button>
              </Col>
              <Col xs={24} sm={20}>
                <h1 className="title">
                  Configurações da instituição
                </h1>
              </Col>
              <Col xs={0} sm={4}>
                <Button
                  type="primary"
                  className="add-procedure"
                  htmlType="submit"
                  loading={this.loading}
                  disabled={!isAdmin}
                  onClick={() => this.handleSubmit(
                    this.state.institution.uuid,
                    this.state.institution_logo[0],
                  )}
                >
                  SALVAR
                </Button>
              </Col>
            </Row>
            <Card
              title="Logomarca da instituição"
              headStyle={{ backgroundColor: '#f2f2f2', paddingLeft: 16 }}
              size="default"
              bodyStyle={{ paddingLeft: 30, paddingBottom: 0 }}
            >
              <Row gutter={28}>

                <Form.Item name="logo" style={{ marginBottom: 0 }}>
                  <FormItem label="Logo">
                    <Avatar
                      shape="square"
                      alt="logo"
                      src={this.state.logo64
                          || this.state.institution.logo_url
                          || null}
                      className="institution-logo-intranet"
                    >
                      Sem logo
                    </Avatar>
                    <div style={{ margin: 8 }} />
                    <Row>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Upload
                          disabled={!isAdmin}
                          onRemove={() => this.setState({
                            institution_logo: [],
                            logo64: null,
                          })}
                          beforeUpload={(file) => {
                            this.setState({
                              institution_logo: [file],
                            });
                            this.viewLogo(file);
                            this.checkValidateFormat(file);
                            return false;
                          }}
                          fileList={this.state.institution_logo}
                        >
                          <Button disabled={!isAdmin}>
                            <Icon type="upload" />
                            {' '}
                            Selecionar arquivo
                          </Button>
                          <div className="ant-upload-list-item-card-actions" />
                        </Upload>
                      </Col>
                    </Row>
                    <span>
                      O tamanho máximo permitido para o arquivo é de 120KB e apenas nos formatos PNG, JPG e JPEG
                    </span>

                  </FormItem>

                </Form.Item>
              </Row>
            </Card>
            <div style={{ margin: 20 }} />
            <Card
              title="Impressão da ficha anestésica"
              headStyle={{ backgroundColor: '#f2f2f2', paddingLeft: 16 }}
              size="default"
              bodyStyle={{ paddingTop: 5 }}
            >
              <Row gutter={28}>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div style={{ margin: 5 }} />
                  {loadingPdfSettings || loadingGroupPdfSettings ? (

                    <Spin />

                  )
                    : (
                      <>

                        <Typography.Text
                          style={{

                            fontWeight: 400,
                          }}
                        >
                          Histórico de alterações
                          {' '}
                        </Typography.Text>

                        <Row>
                          <Typography.Text
                            style={{
                              fontWeight: 400,
                              marginLeft: 11,

                            }}
                          >
                            Ocultar histórico de alterações na geração/impressão da ficha ?
                            {' '}
                            <Switch
                        // eslint-disable-next-line camelcase
                              checked={pdfHistoric}
                              disabled={!isAdmin}
                              onChange={(checked) => {
                                this.setState({ pdfHistoric: checked });
                              }}
                              checkedChildren="Sim"
                              unCheckedChildren="Não"
                            />
                          </Typography.Text>
                        </Row>

                        <Typography.Text
                          style={{

                            fontWeight: 400,
                          }}
                        >
                          PDF
                          {' '}
                        </Typography.Text>

                        <Row>
                          <Typography.Text
                            style={{
                              fontWeight: 400,
                              marginLeft: 11,

                            }}
                          >
                            Mostrar no PDF o grupo de anestesia ?
                            {' '}
                            <Switch
                        // eslint-disable-next-line camelcase
                              checked={pdfGroupHistoric}
                              disabled={!isAdmin}
                              onChange={(checked) => {
                                this.setState({ pdfGroupHistoric: checked });
                              }}
                              checkedChildren="Sim"
                              unCheckedChildren="Não"
                            />
                          </Typography.Text>
                        </Row>

                        <Row style={{ marginTop: 20, marginBottom: 20 }}>
                          <Typography.Text
                            style={{
                              fontWeight: 400,
                              marginLeft: 11,

                            }}
                          >
                            Qual PSC utiliza para assinar documentos?
                            {' '}
                            <Select
                              value={this.state.pscType}
                              disabled={!isAdmin}
                              style={{ width: 160, marginLeft: 8 }}
                              onChange={(val) => this.setState({ pscType: val, pscClientId: '', pscClientSecret: '' })}
                            >
                              <Select.Option value="none">Nenhum</Select.Option>
                              <Select.Option value="vidaas">Vidaas</Select.Option>
                              <Select.Option value="safeid">SafeID</Select.Option>
                            </Select>
                          </Typography.Text>
                          {this.state.pscType !== 'none' && (
                            <Row style={{ marginTop: 12, marginLeft: 11 }}>
                              <Col span={6} style={{ paddingRight: 10 }}>
                                <Typography.Text style={{ fontWeight: 400 }}>Client ID</Typography.Text>
                                <Input
                                  value={this.state.pscClientId}
                                  disabled={!isAdmin}
                                  onKeyUp={(e) => this.setState({ pscClientId: e.target.value })}
                                  onChange={(e) => this.setState({ pscClientId: e.target.value })}
                                  placeholder="Client ID"
                                  style={{ marginTop: 4 }}
                                />
                              </Col>
                              <Col span={6} style={{ paddingRight: 10 }}>
                                <Typography.Text style={{ fontWeight: 400 }}>Client Secret</Typography.Text>
                                <Input
                                  value={this.state.pscClientSecret}
                                  disabled={!isAdmin}
                                  onKeyUp={(e) => this.setState({ pscClientSecret: e.target.value })}
                                  onChange={(e) => this.setState({ pscClientSecret: e.target.value })}
                                  placeholder="Client Secret"
                                  style={{ marginTop: 4 }}
                                />
                              </Col>
                            </Row>
                          )}
                        </Row>

                        <Typography.Text style={{
                          marginTop: 15,
                          fontWeight: 400,

                        }}
                        >
                          Forma de impressão dos fármacos
                        </Typography.Text>
                        <Radio.Group onChange={this.onChange} value={value} disabled={!isAdmin}>
                          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <Radio
                              style={styles.spaceBetweenRadioOptions}
                              value={0}
                            >
                              Nome comercial e princípio ativo

                            </Radio>
                            <Radio
                              style={styles.spaceBetweenRadioOptions}
                              value={1}
                            >
                              Somente princípio ativo

                            </Radio>
                            <Radio
                              style={styles.spaceBetweenRadioOptions}
                              value={2}
                            >
                              Somente nome comercial

                            </Radio>
                          </div>
                        </Radio.Group>
                      </>
                    )}
                </div>
                <Card title="Configuração de Agendamentos" headStyle={{ backgroundColor: '#f2f2f2', paddingLeft: 16 }} size="default" bodyStyle={{ paddingTop: 5 }}>
  <Row gutter={28}>
    <div style={{ display: 'flex', alignItems: 'center' }}> {}
      <Typography.Text style={{ fontWeight: 400, marginRight: 10 }}> {}
        Bloqueia a criação de agendamentos através do AxReg
      </Typography.Text>
      <Switch
        checked={blockAgendaCreation}
        disabled={!isAdmin}
        onChange={this.handleSwitchChange}
        checkedChildren="Sim"
        unCheckedChildren="Não"
      />
    </div>
  </Row>
</Card>

              </Row>
            </Card>
            <div style={{ margin: 20 }} />
            <Card
              title="Consumo de frascos e ampolas"
              headStyle={{ backgroundColor: '#f2f2f2', paddingLeft: 16 }}
              size="default"
              bodyStyle={{ paddingTop: 5 }}
            >
              <Row gutter={28}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  {DRUG_CONSUMPTION_SETTINGS.map(({ key, label }) => (
                    <Row key={key} style={{ marginTop: 12, marginBottom: 8, marginLeft: 11 }}>
                      <Typography.Text style={{ fontWeight: 400, marginRight: 10 }}>
                        {label}
                        {' '}
                        <Switch
                          checked={drugConsumptionSettings[key].value}
                          disabled={!isAdmin}
                          onChange={this.handleDrugConsumptionSettingChange(key)}
                          checkedChildren="Sim"
                          unCheckedChildren="Não"
                        />
                      </Typography.Text>
                    </Row>
                  ))}
                </div>
              </Row>
            </Card>
          </Form>
        </Content>
      );
    }
}

function mapStateToProps(state) { return state; }

const connected = withRouter(connect(mapStateToProps)(Form.create()(Institution)));
export default connected;
